import { render, staticRenderFns } from "./DisplayMenu.vue?vue&type=template&id=1d105ad4&"
import script from "./DisplayMenu.vue?vue&type=script&lang=js&"
export * from "./DisplayMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports